//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import SectionTemplate from "./SectionTemplate.vue";
import * as Forms from "~/components/forms";

export default {
    extends: SectionTemplate,
    components: {
        ...Forms,
    },
    data() {
        return {
            success: null,
        };
    },
    computed: {
        _getTemplate() {
            if (!this.data.form) return false;
            return "Form" + this.data.form;
        },
    },
    created() {
        if (process.browser || process.client) {
            const self = this;

            $(function () {
                const urlHash = self.$route.hash || location.hash;
                const hashElement = $(urlHash);

                if (urlHash === "#success") self.success = true;
                else if (urlHash === "#error") self.success = false;

                if (hashElement.length > 0) {
                    $("html, body").animate(
                        {
                            scrollTop: hashElement.offset().top,
                        },
                        500
                    );
                } else if (urlHash !== "") {
                    $('[data-section="form-request"]')[0].scrollIntoView();
                }

                $('[data-section="form-request"] form').on("submit", function (event) {
                    if (this.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();

                        document.querySelector(".form-control:invalid").focus();
                    }

                    $(this).addClass("was-validated");
                });
            });
        }
    },
};
